import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SfLabelText } from './Filter.style';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState } from 'react';
import { FacetState } from '@coveo/headless';

const EnrollingSiteFilter = (props: any) => {
  const { controller } = props;
  const [state, setState] = useState<FacetState>(controller.state);
  const { fields } = props?.fields?.data[0];

  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  if (!state.values.length) {
    return <></>;
  }

  return (
    <Grid item>
      <FormControlLabel
        label={
          <SfLabelText>
            <Text field={fields.label}></Text>
          </SfLabelText>
        }
        control={
          <Checkbox
            checked={controller.isValueSelected(state.values[0])}
            onChange={() => controller.toggleSelect(state.values[0])}
            disabled={state.isLoading}
            inputProps={{ 'aria-label': fields.label?.value }}
          />
        }
      />
    </Grid>
  );
};

export default EnrollingSiteFilter;
